module.exports = __webpack_public_path__ + "static/img/player_05_program.e76e827.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/player_05_program.svg
// module id = OBu6
// module chunks = 0